import { getData } from "RestControllers/Controller";

const BASE_URL = process.env.REACT_APP_BASE_URL + "studio/monthly-revenue/";

export const getMonthlyRevenue = async (sedeParams = {}) => {
  const response = await getData("GET", BASE_URL, sedeParams);
  return response.data;
};


export const recalculateAllRevenue = async () => {
  const response = await getData("POST", BASE_URL + "recalculate-all/");
  return response.data;
};

export const recalculateMonthlyRevenue = async (year, month) => {
  const response = await getData("POST", BASE_URL + "recalculate/", {}, { year, month });
  return response.data;
};

export const getTotalRevenue = async (sedeParams = {}) => {
  const res = await getData("GET", BASE_URL + "total/", sedeParams);
  return res?.data?.total_revenue || 0;
};


export const getTodayRevenue = async (sedeParams = {}, sedeHeaders = {}) => {
  const response = await getData("GET", process.env.REACT_APP_BASE_URL + "studio/today/", sedeParams, {}, sedeHeaders);
  return response.data;
};

export const getCierresSemanales = async (sedeParams = {}, sedeHeaders = {}) => {
  const response = await getData("GET", process.env.REACT_APP_BASE_URL + "studio/cierres-semanales/", sedeParams, {}, sedeHeaders);
  return response.data;
};